import { generateClassName } from "@smoothincorg/smooth-ui"
import React from "react"
import styled, { css } from "styled-components"

type FlexProps = {
  children?: React.ReactNode
  className?: string
  container?: boolean
  /****** Container Props ********/
  flexDirection?: "row" | "column"
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "initial"
    | "inherit"
  flexWrap?: "wrap" | "nowrap" | "wrap-reverse"
  alignItems?: "stretch" | "center" | "flex-start" | "flex-end" | "baseline" | "initial" | "inherit"
  /****** Child Props ********/
  flexGrow?: number
  flexShrink?: number
  flexBasis?: number
  flex?: string
  /****** Common Layout Props ********/
  padding?: string
  margin?: string
  width?: number
  height?: number
  maxWidth?: string
  maxHeight?: string
}

const { getRootClassName } = generateClassName("FlexBox")

const Component: React.FC<FlexProps> = (props) => (
  <div className={getRootClassName(props)}>{props.children}</div>
)

export const FlexBox = styled(Component).withConfig({})(
  ({ container = true, width, height, ...props }) => css`
    display: ${container ? "flex" : "block"};
    justify-content: ${props.justifyContent || "flex-start"};
    flex-direction: ${props.flexDirection || "row"};
    grow: ${props.flexGrow || 0};
    flex-basis: ${props.flexBasis || "auto"};
    shrink: ${props.flexShrink || 1};
    flex-wrap: ${props.flexWrap || "nowrap"};
    flex: ${props.flex || "0 1 auto"};
    align-items: ${props.alignItems || "stretch"};
    margin: ${props.margin || "0"};
    padding: ${props.padding || "0"};
    max-width: ${props.maxWidth || "none"};
    width: ${typeof width === "number" ? `${width}px` : width ?? "auto"};
    height: ${typeof height === "number" ? `${height}px` : height ?? "auto"};
  `
)
